import React, { useState } from 'react';
import { useStore } from 'store/storeUtils';
import { useHistory } from 'react-router-dom';
import { logger } from "@tecma/logs-fe";
import { observer } from 'mobx-react';

const LogoutListener = observer(() => {

  const store = useStore();
  const history = useHistory();
  const [loggingOut, setLoggingOut] = useState(false);

  const clearStore = () => {
    try {
      store.logOut();
    } catch (e) {
      logger.error(e);
    }
  };

  if (!loggingOut && store.redirectionToSsoNeeded) {
    setLoggingOut(true);
    clearStore();
    history.push('/login');
  }

  return <></>;
});

export default LogoutListener;
